import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Divider from "../../../components/Divider";
import TwoSections from "../../../components/TwoSections";
import TwoSectionsImages from "../../../components/TwoSectionsImages";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const GifPlayer = makeShortcode("GifPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Play zones are the social hubs for IBM team members to unwind, reset and converse. The spaces can accommodate spontaneous or planned events intended to inspire and support the creative process.`}</p>
    </PageDescription>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <video autoPlay playsInline loop="on" muted src="/workplace-xg/d6e74cccf02948ecd00ed2cebd4b9026/play.mp4" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMCBP/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAFuKXpVJ//EABsQAAICAwEAAAAAAAAAAAAAAAABAhEDBBAj/9oACAEBAAEFAnH0vEVBiNbn/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/AUyf/8QAFREBAQAAAAAAAAAAAAAAAAAAERD/2gAIAQIBAT8BWf/EABsQAAEEAwAAAAAAAAAAAAAAAAABEBESMTJB/9oACAEBAAY/ApStemxhlb//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhQTFh/9oACAEBAAE/IScQOF2IdVLVifsalcSaL7tSq8n/2gAMAwEAAgADAAAAEA8//8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EBeT/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAh/9oACAECAQE/EBbn/8QAGxABAAICAwAAAAAAAAAAAAAAAREhAFExYXH/2gAIAQEAAT8QTcpoiTcR1j0lYB0+4oD9GnvnBDbK7b3npi11OQoANBn/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animation of various play zone configurations",
              "title": "animation of various play zone configurations",
              "src": "/workplace-xg/static/1841de28443f5341854c964efa33e0b3/2e753/play-zone-with-game-tables.jpg",
              "srcSet": ["/workplace-xg/static/1841de28443f5341854c964efa33e0b3/69549/play-zone-with-game-tables.jpg 288w", "/workplace-xg/static/1841de28443f5341854c964efa33e0b3/473e3/play-zone-with-game-tables.jpg 576w", "/workplace-xg/static/1841de28443f5341854c964efa33e0b3/2e753/play-zone-with-game-tables.jpg 1152w", "/workplace-xg/static/1841de28443f5341854c964efa33e0b3/040c5/play-zone-with-game-tables.jpg 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <h2>{`Signature moments`}</h2>
    <p>{`Play zones are centrally located. They can house events, programs and light refreshments to spontaneously bring team members together. The central purpose of this zone is to provide a sharp contrast with the work areas, and to support the freedom to have a change of pace within the workday.`}</p>
    <Divider mdxType="Divider" />
    <TwoSections title="Finish palette" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
  For Play zones, bolder patterns can be featured on surfaces, including area rugs and furniture upholstery.
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAQFBgP/xAAXAQEAAwAAAAAAAAAAAAAAAAAAAgME/9oADAMBAAIQAxAAAAHP62FYk9HFML49xnf/xAAcEAACAgIDAAAAAAAAAAAAAAAAAgERAxIFFDT/2gAIAQEAAQUCOP8AKdXEYV0S5JZqR3rdj//EABkRAAIDAQAAAAAAAAAAAAAAAAABBBAhMf/aAAgBAwEBPwGpePBcP//EABgRAAIDAAAAAAAAAAAAAAAAAAEQAhET/9oACAECAQE/AVADK1//xAAbEAACAgMBAAAAAAAAAAAAAAAAMQECEBIyof/aAAgBAQAGPwIrhemtUMZ1J1J//8QAHRAAAgIBBQAAAAAAAAAAAAAAAAEQIRExQWGhsf/aAAgBAQABPyE7T9i3WFZ1pXRyDccIIT//2gAMAwEAAgADAAAAEMDH/wD/xAAYEQACAwAAAAAAAAAAAAAAAAAAMRAhcf/aAAgBAwEBPxCK64KP/8QAGREAAgMBAAAAAAAAAAAAAAAAAAEQESEx/9oACAECAQE/EIYsWi4f/8QAHxABAAIABgMAAAAAAAAAAAAAAQARECExQVHwYXHR/9oACAEBAAE/EJ2fLCoC57wOxVLvXPVnWPkMEvy38QVAjN1iL5nef//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "play zone finish palette",
            "title": "play zone finish palette",
            "src": "/workplace-xg/static/41d1ac344d14a8a462c2b6c12a7b27a9/2e753/play-zone-finish-palette.jpg",
            "srcSet": ["/workplace-xg/static/41d1ac344d14a8a462c2b6c12a7b27a9/69549/play-zone-finish-palette.jpg 288w", "/workplace-xg/static/41d1ac344d14a8a462c2b6c12a7b27a9/473e3/play-zone-finish-palette.jpg 576w", "/workplace-xg/static/41d1ac344d14a8a462c2b6c12a7b27a9/2e753/play-zone-finish-palette.jpg 1152w", "/workplace-xg/static/41d1ac344d14a8a462c2b6c12a7b27a9/a052a/play-zone-finish-palette.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Color strategy" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
  Play zones can incorporate more color and pattern to imply enhanced social activity. A broader spectrum of accent colors in textiles, finishes and graphics reinforces our sense of diversity and underscores inclusion within our Be Equal® program.
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGZsVcusKE//8QAHRAAAQQCAwAAAAAAAAAAAAAAAgABAwQREhMxMv/aAAgBAQABBQIwDlrhpLlk/db0EYL/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAABBAMBAAAAAAAAAAAAAAAAAQIRIRAxQVH/2gAIAQEABj8Cc2mx4KkzRvCi10//xAAcEAACAgIDAAAAAAAAAAAAAAAAASExEcFBUWH/2gAIAQEAAT8hjhFG2iBNSYn8Vj0nk5Ze6WyVu8mf/9oADAMBAAIAAwAAABDI3//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/EKf/xAAWEQEBAQAAAAAAAAAAAAAAAAAAESH/2gAIAQIBAT8QmI//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhQWEx/9oACAEBAAE/EFdJGtcx17uQKyNBn1l0F5SINjWVQVVtdhruFPMRw4Vpbq1P/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "play zone color strategy",
            "title": "play zone color strategy",
            "src": "/workplace-xg/static/81583ec323907b55c6d26545dce569e1/2e753/play-zone-color-strategy.jpg",
            "srcSet": ["/workplace-xg/static/81583ec323907b55c6d26545dce569e1/69549/play-zone-color-strategy.jpg 288w", "/workplace-xg/static/81583ec323907b55c6d26545dce569e1/473e3/play-zone-color-strategy.jpg 576w", "/workplace-xg/static/81583ec323907b55c6d26545dce569e1/2e753/play-zone-color-strategy.jpg 1152w", "/workplace-xg/static/81583ec323907b55c6d26545dce569e1/040c5/play-zone-color-strategy.jpg 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Brand expression" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
  
        <p>These communal spaces are ideal locations to reinforce IBM’s commitment to diversity and inclusion. Be Equal is an internal and external program designed by IBM to expand, enable and ensure equality for everyone. Be Equal can be expressed in the environment in a variety of ways, both large and small. We invite IBM employees and clients to make their own pledge of commitment within the program.</p>
        <p>{`Other elements can also complement Connect zones, such as our iconic Think® identity, typographic patterns or rebus symbol. Learn more about `}<a parentName="p" {...{
            "href": "/workplace-xg/brand-expression/overview/#environmental-elements"
          }}>{`environmental elements and branding`}</a>{`.`}</p>
      </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAQL/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB7Tr4nLg//8QAGhAAAgMBAQAAAAAAAAAAAAAAAQIAAxESIf/aAAgBAQABBQICtq+BMWWqAueBRn//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAACAgMBAAAAAAAAAAAAAAAAARExAhBBYf/aAAgBAQAGPwKZOpeloxhd1R//xAAYEAEBAQEBAAAAAAAAAAAAAAARAAEhUf/aAAgBAQABPyHMBijM7BlWEAcQfPIbi//aAAwDAQACAAMAAAAQvz//xAAWEQEBAQAAAAAAAAAAAAAAAAAAETH/2gAIAQMBAT8QxX//xAAWEQEBAQAAAAAAAAAAAAAAAAAAETH/2gAIAQIBAT8Q1H//xAAbEAEAAgMBAQAAAAAAAAAAAAABABEhQVFxkf/aAAgBAQABPxDPYUnlBmB0qBDS71BlVe3AUDG0Xdz7xA8Lk//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Bristol kitchen pledge wall",
              "title": "Bristol kitchen pledge wall",
              "src": "/workplace-xg/static/3e9212df67428dc9d6084c384cfac9d5/2e753/bristol-kitchen-pledge-wall.jpg",
              "srcSet": ["/workplace-xg/static/3e9212df67428dc9d6084c384cfac9d5/69549/bristol-kitchen-pledge-wall.jpg 288w", "/workplace-xg/static/3e9212df67428dc9d6084c384cfac9d5/473e3/bristol-kitchen-pledge-wall.jpg 576w", "/workplace-xg/static/3e9212df67428dc9d6084c384cfac9d5/2e753/bristol-kitchen-pledge-wall.jpg 1152w", "/workplace-xg/static/3e9212df67428dc9d6084c384cfac9d5/a052a/bristol-kitchen-pledge-wall.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIEA//EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAF6cJorEK//xAAbEAADAAIDAAAAAAAAAAAAAAAAAQIDBBESE//aAAgBAQABBQLEpkVJKlXOLojbaPQ//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAHhAAAQQBBQAAAAAAAAAAAAAAAAIREiEBECIyYXH/2gAIAQEABj8CXF+TWbvCkme7Ex0//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARMSFRcf/aAAgBAQABPyHYVYJhFriP5k+xhYW2vYG4qmdg1XJ//9oADAMBAAIAAwAAABD0D//EABYRAQEBAAAAAAAAAAAAAAAAAAARIf/aAAgBAwEBPxC4r//EABYRAQEBAAAAAAAAAAAAAAAAAAARIf/aAAgBAgEBPxCaj//EABsQAQACAwEBAAAAAAAAAAAAAAEAETFBUSGh/9oACAEBAAE/ECgBsakHmoIcLafY1e5QTK5ay3s5itIVqvJUZWDQz//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "IBM Be Equal poster",
              "title": "IBM Be Equal poster",
              "src": "/workplace-xg/static/cbf4631cfef4f7d270deee476e4348d8/473e3/ibm-be-equal-wood-poster.jpg",
              "srcSet": ["/workplace-xg/static/cbf4631cfef4f7d270deee476e4348d8/69549/ibm-be-equal-wood-poster.jpg 288w", "/workplace-xg/static/cbf4631cfef4f7d270deee476e4348d8/473e3/ibm-be-equal-wood-poster.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMBAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAG3FMqYgf/EABsQAQACAgMAAAAAAAAAAAAAAAEAAgMREhMx/9oACAEBAAEFAqBrIDVxSvl3idrP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFhAAAwAAAAAAAAAAAAAAAAAAACAh/9oACAEBAAY/Alh//8QAGRAAAgMBAAAAAAAAAAAAAAAAAAERITFR/9oACAEBAAE/IbDXwaGolcMYnC8VpZNW8Q6oH//aAAwDAQACAAMAAAAQZC//xAAXEQEAAwAAAAAAAAAAAAAAAAAAARFB/9oACAEDAQE/ENVL/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAERQf/aAAgBAgEBPxDFw//EABwQAQACAgMBAAAAAAAAAAAAAAEAESExYXGhwf/aAAgBAQABPxC9QWUfUBMNhW+IqPeFK0wiNWTfnkq9A6CGBRRnuf/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "play zone brand expression signage",
              "title": "play zone brand expression signage",
              "src": "/workplace-xg/static/ec7e7cbacd86f4c9b4c489b4bdd676ac/473e3/play-zone-brand-expression-signage.jpg",
              "srcSet": ["/workplace-xg/static/ec7e7cbacd86f4c9b4c489b4bdd676ac/69549/play-zone-brand-expression-signage.jpg 288w", "/workplace-xg/static/ec7e7cbacd86f4c9b4c489b4bdd676ac/473e3/play-zone-brand-expression-signage.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
   <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAED/9oADAMBAAIQAxAAAAFpaVGIxSf/xAAaEAACAwEBAAAAAAAAAAAAAAACEQABEiED/9oACAEBAAEFAkK7FB8leb2fC//EABYRAQEBAAAAAAAAAAAAAAAAAAARIf/aAAgBAwEBPwGNf//EABgRAAIDAAAAAAAAAAAAAAAAAAABAhJR/9oACAECAQE/AbCUdP/EABoQAAIDAQEAAAAAAAAAAAAAAAARASFhAzH/2gAIAQEABj8Ch9CkmemGFRB//8QAHBABAAICAwEAAAAAAAAAAAAAAQARIUExUWHh/9oACAEBAAE/IU624lqS4nuV+CBeV4iQ143C5EOck//aAAwDAQACAAMAAAAQsz//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQMBAT8QilzL/8QAFhEAAwAAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/EIGFR//EABwQAQEAAgIDAAAAAAAAAAAAAAERACExQWFxgf/aAAgBAQABPxBSGi1Cc9eMo0AGMjuXHvd+GIOF095DHUEQPuy4u3QoMVc//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "brand expression in play zone",
              "title": "brand expression in play zone",
              "src": "/workplace-xg/static/4019398f98b7b21ee8a9169aa23c8720/2e753/brand-expression-in-play-zone.jpg",
              "srcSet": ["/workplace-xg/static/4019398f98b7b21ee8a9169aa23c8720/69549/brand-expression-in-play-zone.jpg 288w", "/workplace-xg/static/4019398f98b7b21ee8a9169aa23c8720/473e3/brand-expression-in-play-zone.jpg 576w", "/workplace-xg/static/4019398f98b7b21ee8a9169aa23c8720/2e753/brand-expression-in-play-zone.jpg 1152w", "/workplace-xg/static/4019398f98b7b21ee8a9169aa23c8720/a052a/brand-expression-in-play-zone.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Furniture" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
The environment should offer a broad range of seating. Choose furniture that invites a variety of engagement opportunities. For example, mix intimate settings, such as banquettes or booths, alongside more open conversational furniture, such as sofas, benches and lounge chairs.
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABy3TU5JGFf//EABsQAAICAwEAAAAAAAAAAAAAAAACAQMREhMh/9oACAEBAAEFAq64cikbxlzBDOc9j//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAECAQE/Aaf/xAAaEAEBAAIDAAAAAAAAAAAAAAAAARESITFh/9oACAEBAAY/Al8WOHcZ2j//xAAcEAACAgIDAAAAAAAAAAAAAAABEQAxIUFRYXH/2gAIAQEAAT8hsCrgXmFs7niSpvIGCsnUJkbHLn//2gAMAwEAAgADAAAAEAgv/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAgEBPxBqsZT/xAAcEAEBAAICAwAAAAAAAAAAAAABEQAxIZFB0eH/2gAIAQEAAT8Q403IrNT3iSFWHxYpGm6Y5pjfJh1HtdsSoKrFXrP/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "play zone furniture with plant wall",
              "title": "play zone furniture with plant wall",
              "src": "/workplace-xg/static/10de4ddcef1ceb3e35fcce545289a165/4edc6/play-zone-furniture-with-plant-wall.jpg",
              "srcSet": ["/workplace-xg/static/10de4ddcef1ceb3e35fcce545289a165/69549/play-zone-furniture-with-plant-wall.jpg 288w", "/workplace-xg/static/10de4ddcef1ceb3e35fcce545289a165/473e3/play-zone-furniture-with-plant-wall.jpg 576w", "/workplace-xg/static/10de4ddcef1ceb3e35fcce545289a165/4edc6/play-zone-furniture-with-plant-wall.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAECAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAfexcTXZFzaEB//EABoQAAEFAQAAAAAAAAAAAAAAAAEAAhAREjH/2gAIAQEAAQUCJpbhws4Q5P8A/8QAFREBAQAAAAAAAAAAAAAAAAAAICH/2gAIAQMBAT8Bg//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABgQAAIDAAAAAAAAAAAAAAAAAAABECAx/9oACAEBAAY/ApRrr//EABkQAQACAwAAAAAAAAAAAAAAABEAMQEQIP/aAAgBAQABPyEDA1oIkrmVHH//2gAMAwEAAgADAAAAEBvIPP/EABcRAQADAAAAAAAAAAAAAAAAAAERICH/2gAIAQMBAT8QCG0//8QAFREBAQAAAAAAAAAAAAAAAAAAICH/2gAIAQIBAT8Qo//EABoQAQEAAwEBAAAAAAAAAAAAAAERACExECD/2gAIAQEAAT8QK7e4ZoDAvb4oCBXWKhanHFUWsPj/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "colorful play zone chair",
              "title": "colorful play zone chair",
              "src": "/workplace-xg/static/0eb4224e607f56c7cfdb04e1e005a771/473e3/colorful-play-zone-chair.jpg",
              "srcSet": ["/workplace-xg/static/0eb4224e607f56c7cfdb04e1e005a771/69549/colorful-play-zone-chair.jpg 288w", "/workplace-xg/static/0eb4224e607f56c7cfdb04e1e005a771/473e3/colorful-play-zone-chair.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "151.04166666666669%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAwABAgT/xAAXAQEBAQEAAAAAAAAAAAAAAAAAAgED/9oADAMBAAIQAxAAAAEfQC823NtFp5cJFH//xAAbEAADAAMBAQAAAAAAAAAAAAAAAQIDEyESM//aAAgBAQABBQK3zH82jXTU8h0h5CH6TkWKSpk1yf/EABURAQEAAAAAAAAAAAAAAAAAAAEg/9oACAEDAQE/ASP/xAAVEQEBAAAAAAAAAAAAAAAAAAARIP/aAAgBAgEBPwEj/8QAHhAAAgEDBQAAAAAAAAAAAAAAAAERECEyAiJBcZH/2gAIAQEABj8CiBUvIlXJLsz0+l5Ytpyf/8QAHBAAAgMBAQEBAAAAAAAAAAAAAAERIUExUZHw/9oACAEBAAE/IWYPWvR5OwaeiOJ4XjqJBT0Q7VoRJkLdvwkqkV4fgz//2gAMAwEAAgADAAAAENwBw//EABgRAAIDAAAAAAAAAAAAAAAAAAABEBEh/9oACAEDAQE/EMMtT//EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQIBAT8QFMb/AP/EACIQAQACAQMDBQAAAAAAAAAAAAEAEUEhMZFRYXGBobHR8P/aAAgBAQABPxC+BA1ozw/Yliej8sKb3bNFU5uNdlKNN5mUgbqSltcNlYJlvq+pzCFPaUgTVpWGN2iexP8A/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "play zone plant wall detail",
              "title": "play zone plant wall detail",
              "src": "/workplace-xg/static/d6af478919a84c869b8fdadebc4fa831/473e3/play-zone-plant-wall-detail.jpg",
              "srcSet": ["/workplace-xg/static/d6af478919a84c869b8fdadebc4fa831/69549/play-zone-plant-wall-detail.jpg 288w", "/workplace-xg/static/d6af478919a84c869b8fdadebc4fa831/473e3/play-zone-plant-wall-detail.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8UlEQVQoz9WSUWvCMBSF+/9/hFqm4IsyWGU4NxpbabWyOSvUYZFsWIQxmKBJTNL0dkn1xecNhh8n4SY5lwuHWOUvsK63uagAIwVQlFAAKHOlNzCH4hKo+IvJLkKvo+FniL7m6IDHcJin2FskoYf8l+1+hrfhyI/jeLlMVqsUr9Ns87HbfSulLClErdF4bLeSbuvt3s6eOyTrBdNm/6lt129uF9ldlDTtuuM4g8GDi9zA96JJgN8xIcTK81wIwY6cCkm5oFwSJoU06CfJmV7awDk/GjhljFIj7TkHBidV6ZQmsXNMOpZTBZdoz3V/kv9p/gGwc2eTThArQwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "colorful chairs for play zone",
              "title": "colorful chairs for play zone",
              "src": "/workplace-xg/static/3d0728982e233f479b751657e2cef919/a5df1/colorful-chairs-for-play-zone.png",
              "srcSet": ["/workplace-xg/static/3d0728982e233f479b751657e2cef919/7fc1e/colorful-chairs-for-play-zone.png 288w", "/workplace-xg/static/3d0728982e233f479b751657e2cef919/a5df1/colorful-chairs-for-play-zone.png 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
   <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIDBf/EABYBAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB6KmWalf/xAAZEAADAAMAAAAAAAAAAAAAAAAAARECEhP/2gAIAQEAAQUCpRNM5qvA0P/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAQADAAAAAAAAAAAAAAAAABAAESH/2gAIAQEABj8CMlv/xAAaEAEAAwADAAAAAAAAAAAAAAABABExIUFh/9oACAEBAAE/IaKg5KOMEtXH0Jw7Cvc//9oADAMBAAIAAwAAABCv3//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ECf/xAAXEQADAQAAAAAAAAAAAAAAAAABEBFB/9oACAECAQE/EDcX/8QAHBABAQADAAMBAAAAAAAAAAAAAREAITFBUXGR/9oACAEBAAE/EAwF0S8wVAfmQRFSj5Minmx9XuUAAjefmIHXbXWf/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "stools and chairs for play zone",
              "title": "stools and chairs for play zone",
              "src": "/workplace-xg/static/0d82931f779240d09e51e535fb4c511c/473e3/stools-and-chairs-for-play-zone.jpg",
              "srcSet": ["/workplace-xg/static/0d82931f779240d09e51e535fb4c511c/69549/stools-and-chairs-for-play-zone.jpg 288w", "/workplace-xg/static/0d82931f779240d09e51e535fb4c511c/473e3/stools-and-chairs-for-play-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Flooring and ceiling" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
        <p>Concrete flooring is appropriate for the Play zone. Care should be used to provide an appropriate floor surface for the activity of the space. The use of specialty felt ceiling systems or open ceilings can be used to help define this zone.</p>
        <p>
  The lighting in the Play zone should complement the ceiling elements in this
  space. A combination of linear fixtures and downlights should work to
  illuminate special Play zone features and game activities. Decorative pendants
  should be suspended over the bar-height counters.
        </p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAGqaoEhiP/EABUQAQEAAAAAAAAAAAAAAAAAABAB/9oACAEBAAEFAmv/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAYEAEBAQEBAAAAAAAAAAAAAAAAAREhMf/aAAgBAQABPyGxmdepVX//2gAMAwEAAgADAAAAEBj/AP/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/ECf/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxBn/8QAGxABAAMAAwEAAAAAAAAAAAAAAQARITFBUXH/2gAIAQEAAT8QxpCI9K6COrqoVuQm/Zyn/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "perforated metal ceiling",
              "title": "perforated metal ceiling",
              "src": "/workplace-xg/static/1dd62b205eea274b540d576ac1a233ac/4edc6/perforated-metal-ceiling.jpg",
              "srcSet": ["/workplace-xg/static/1dd62b205eea274b540d576ac1a233ac/69549/perforated-metal-ceiling.jpg 288w", "/workplace-xg/static/1dd62b205eea274b540d576ac1a233ac/473e3/perforated-metal-ceiling.jpg 576w", "/workplace-xg/static/1dd62b205eea274b540d576ac1a233ac/4edc6/perforated-metal-ceiling.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAEDBQIE/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAfPN8xS2FZHYVBP/xAAbEAEBAQACAwAAAAAAAAAAAAABAgMAERITIf/aAAgBAQABBQJeg8q4zvzXrScS5B+Ie1gnkb2H/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQIf/aAAgBAwEBPwFm3//EABkRAAIDAQAAAAAAAAAAAAAAAAERABBBUf/aAAgBAgEBPwELYxy//8QAHRAAAgMAAgMAAAAAAAAAAAAAAAECESEiMVFxkf/aAAgBAQAGPwLVRwjZkH8IpOJld+TRKkWju/Z//8QAHBABAQEBAAIDAAAAAAAAAAAAAREAITFBUXGB/9oACAEBAAE/IZTA+K6aiL6LhvQauCC8XKYT8A5YruTHCXmr1P3QsfRd/9oADAMBAAIAAwAAABCMKAP/xAAZEQADAAMAAAAAAAAAAAAAAAAAAREQIVH/2gAIAQMBAT8QZ3ROhY//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQIBAT8QONgUbC//xAAdEAEBAAICAwEAAAAAAAAAAAABEQAhMUFRYYGR/9oACAEBAAE/EHJgbyFxv1AKfWQXnVZRGER9cYRBKkjR4cCDklPebVDATce/mKIYaHAcomxaC/c//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "felt ceiling in play zone",
              "title": "felt ceiling in play zone",
              "src": "/workplace-xg/static/7e2c3197280acd559306f5ef98082516/473e3/felt-ceiling-in-play-zone.jpg",
              "srcSet": ["/workplace-xg/static/7e2c3197280acd559306f5ef98082516/69549/felt-ceiling-in-play-zone.jpg 288w", "/workplace-xg/static/7e2c3197280acd559306f5ef98082516/473e3/felt-ceiling-in-play-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIEAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAgH/2gAMAwEAAhADEAAAAdHn5LmrcAs2ZB//xAAcEAACAgIDAAAAAAAAAAAAAAABAgAQERITISL/2gAIAQEAAQUC5fJXrdopjOWrEFf/xAAYEQACAwAAAAAAAAAAAAAAAAAAARAREv/aAAgBAwEBPwG0ac//xAAXEQADAQAAAAAAAAAAAAAAAAAAEBFB/9oACAECAQE/AdI//8QAGhAAAgMBAQAAAAAAAAAAAAAAAAERITEgUf/aAAgBAQAGPwKKKbNJ8FJvH//EABwQAQACAgMBAAAAAAAAAAAAAAEAERAhMUFRof/aAAgBAQABPyF26D2AWq+rzAiikY5U/UGS6w0m3WP/2gAMAwEAAgADAAAAEB/AQf/EABcRAAMBAAAAAAAAAAAAAAAAAAARQRD/2gAIAQMBAT8Qohl3/8QAGBEAAgMAAAAAAAAAAAAAAAAAAREAECH/2gAIAQIBAT8QL0Yl/wD/xAAfEAEAAgICAgMAAAAAAAAAAAABABEhQTFhgZFRscH/2gAIAQEAAT8QyRpopzn9jA1mKfgcvmGKQ6te2Mm5rsa9fUztBFd3zAsyojjv5lBSPUTM/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "polished concrete floor in play zone",
              "title": "polished concrete floor in play zone",
              "src": "/workplace-xg/static/90cc75cc8ae41c09405d21cba589eca4/473e3/polished-concrete-floor-in-play-zone.jpg",
              "srcSet": ["/workplace-xg/static/90cc75cc8ae41c09405d21cba589eca4/69549/polished-concrete-floor-in-play-zone.jpg 288w", "/workplace-xg/static/90cc75cc8ae41c09405d21cba589eca4/473e3/polished-concrete-floor-in-play-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAwABBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFQ6Bwdsv8A/8QAGBAAAwEBAAAAAAAAAAAAAAAAAQIQEQD/2gAIAQEAAQUCdYEOZxUT/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BiP/EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/Aar/xAAXEAADAQAAAAAAAAAAAAAAAAAQESAx/9oACAEBAAY/AnGD/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAERMVEh/9oACAEBAAE/IaLpaTEOCHon6hX0/9oADAMBAAIAAwAAABCMD//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EC3/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPxAl/8QAHRABAAIBBQEAAAAAAAAAAAAAAQARITFBUWFxwf/aAAgBAQABPxBeNV2NmDSrRfkAIY9iKhZ7EkA8xLAqO5//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "felt ceiling in play zone",
              "title": "felt ceiling in play zone",
              "src": "/workplace-xg/static/005c63f84d7bd6c679a517c8320500d7/4edc6/felt-ceiling-in-play-zone-1.jpg",
              "srcSet": ["/workplace-xg/static/005c63f84d7bd6c679a517c8320500d7/69549/felt-ceiling-in-play-zone-1.jpg 288w", "/workplace-xg/static/005c63f84d7bd6c679a517c8320500d7/473e3/felt-ceiling-in-play-zone-1.jpg 576w", "/workplace-xg/static/005c63f84d7bd6c679a517c8320500d7/4edc6/felt-ceiling-in-play-zone-1.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
   <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBQEE/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAGU+egc1NGfYGqxX//EABoQAAIDAQEAAAAAAAAAAAAAAAACAREhEgP/2gAIAQEAAQUCXpyvQmXtZols5YiS8bT/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/AR//xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAECAQE/AR//xAAbEAABBQEBAAAAAAAAAAAAAAAAARARITFBof/aAAgBAQAGPwKlN9NMS8s5KHGhv//EABsQAQADAQADAAAAAAAAAAAAAAEAESFBUYGR/9oACAEBAAE/IXtW9OSq/RjuJQQHwCMkBVXuRdx+4wVyWbHCK1s//9oADAMBAAIAAwAAABBzMH3/xAAVEQEBAAAAAAAAAAAAAAAAAAARIP/aAAgBAwEBPxAj/8QAFREBAQAAAAAAAAAAAAAAAAAAESD/2gAIAQIBAT8QY//EACAQAQEAAgEDBQAAAAAAAAAAAAERACExYaHRQVFxgfD/2gAIAQEAAT8QUYoIMrp0xJELsi0/dsDB908ZxdnQVjvvnJFIOnq4+XHx85O2J2ZHRTR7YprWZ//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "open ceiling in play zone",
              "title": "open ceiling in play zone",
              "src": "/workplace-xg/static/07dfebb1b17eff62ad898fa72c7ca896/473e3/open-ceiling-in-play-zone.jpg",
              "srcSet": ["/workplace-xg/static/07dfebb1b17eff62ad898fa72c7ca896/69549/open-ceiling-in-play-zone.jpg 288w", "/workplace-xg/static/07dfebb1b17eff62ad898fa72c7ca896/473e3/open-ceiling-in-play-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
     <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75.34722222222221%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAdIo3LzR4T//xAAYEAADAQEAAAAAAAAAAAAAAAAAAQISEf/aAAgBAQABBQLNDhjg10gdH//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABkQAAIDAQAAAAAAAAAAAAAAAAAhAhAxQf/aAAgBAQAGPwLLUhnD/8QAGhAAAwEBAQEAAAAAAAAAAAAAAAERIUExYf/aAAgBAQABPyGTbvTqo5PTqwffEIOJZ+H/2gAMAwEAAgADAAAAECjf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAAMBAQEBAAAAAAAAAAAAAQARITFBkfD/2gAIAQEAAT8QdUdNke1w2wyESo17jAbS+lJ7+9lFrxxbY+U41L9n/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "linear pendant lighting in play zone",
              "title": "linear pendant lighting in play zone",
              "src": "/workplace-xg/static/e717acd6e91dd99f0223cd4036a89b6d/473e3/linear-pendant-lighting-in-play-zone.jpg",
              "srcSet": ["/workplace-xg/static/e717acd6e91dd99f0223cd4036a89b6d/69549/linear-pendant-lighting-in-play-zone.jpg 288w", "/workplace-xg/static/e717acd6e91dd99f0223cd4036a89b6d/473e3/linear-pendant-lighting-in-play-zone.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Biophilic design" mdxType="TwoSections">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Aligned with our principle characteristic of duality, biophilic elements integrate nature into the build environment. This principle can be integrated in a variety of ways using natural plants, biophilic forms and access to natural light when possible. Special care should be taken when considering long-term maintenance. Living elements should be designed as part of the architecture and finish palette. Avoid residential use of plants in individually potted or decorative pieces.`}</p>
      </Column>
      <TwoSectionsImages mdxType="TwoSectionsImages">
        <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAe6y+ct8jE//xAAaEAEAAgMBAAAAAAAAAAAAAAABAAIDERMU/9oACAEBAAEFArNsRuzAJ6Nves7k/8QAFhEBAQEAAAAAAAAAAAAAAAAAABES/9oACAEDAQE/AYy//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8BV//EABwQAAICAgMAAAAAAAAAAAAAAAAhARECEjFRsf/aAAgBAQAGPwLGp5nofgoL1HiKz//EAB4QAQACAgEFAAAAAAAAAAAAAAEAESFRMUGB0eHx/9oACAEBAAE/IRB2zabIBxXJiTBAWTe69xd36+xXoHfzP//aAAwDAQACAAMAAAAQsy//xAAXEQEAAwAAAAAAAAAAAAAAAAABEBEx/9oACAEDAQE/EG7sf//EABYRAAMAAAAAAAAAAAAAAAAAABAhMf/aAAgBAgEBPxCoP//EABwQAQADAAIDAAAAAAAAAAAAAAEAESFBUTGRsf/aAAgBAQABPxAhZgMDM84XcFve5tOWiMGiu1yxwn1W+xotVe0haz0FFeo//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "biophilic design 1",
              "title": "biophilic design 1",
              "src": "/workplace-xg/static/b4018819036cad6824ffd84055f475d5/2e753/biophilic-design-1.jpg",
              "srcSet": ["/workplace-xg/static/b4018819036cad6824ffd84055f475d5/69549/biophilic-design-1.jpg 288w", "/workplace-xg/static/b4018819036cad6824ffd84055f475d5/473e3/biophilic-design-1.jpg 576w", "/workplace-xg/static/b4018819036cad6824ffd84055f475d5/2e753/biophilic-design-1.jpg 1152w", "/workplace-xg/static/b4018819036cad6824ffd84055f475d5/a052a/biophilic-design-1.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </Column>
        <Column mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMCBAX/xAAXAQADAQAAAAAAAAAAAAAAAAAAAQID/9oADAMBAAIQAxAAAAFUdFeVpLAP/8QAGxAAAgIDAQAAAAAAAAAAAAAAAAECEgMTIjL/2gAIAQEAAQUCfojDmqZpxlUj/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BV//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/AUf/xAAbEAACAQUAAAAAAAAAAAAAAAAAEQEQITEyQf/aAAgBAQAGPwJQzpfIpNaf/8QAHBAAAwACAwEAAAAAAAAAAAAAAAERIXExgZHR/9oACAEBAAE/IVsvUacwLpL2GvCrZm+mcRX1n//aAAwDAQACAAMAAAAQBB//xAAXEQEBAQEAAAAAAAAAAAAAAAABABEh/9oACAEDAQE/EEd4xkv/xAAWEQEBAQAAAAAAAAAAAAAAAAABAFH/2gAIAQIBAT8QAlbf/8QAGxABAQADAQEBAAAAAAAAAAAAAREAITGh4fH/2gAIAQEAAT8QVbjwWrLq5CU2KilPPMdHYvCYJSKIUbxmZo6/TONJ2fbP/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "biophilic design 2",
              "title": "biophilic design 2",
              "src": "/workplace-xg/static/53a12562fd5c95f801e52503edfd5eef/2e753/biophilic-design-2.jpg",
              "srcSet": ["/workplace-xg/static/53a12562fd5c95f801e52503edfd5eef/69549/biophilic-design-2.jpg 288w", "/workplace-xg/static/53a12562fd5c95f801e52503edfd5eef/473e3/biophilic-design-2.jpg 576w", "/workplace-xg/static/53a12562fd5c95f801e52503edfd5eef/2e753/biophilic-design-2.jpg 1152w", "/workplace-xg/static/53a12562fd5c95f801e52503edfd5eef/a052a/biophilic-design-2.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </Column>
      </TwoSectionsImages>
    </TwoSections>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      